import React, { FC } from 'react'
import { Button, Modal } from '../../../../common'
import { Title } from '../../../../common/text'
import { Close } from '../../../../common/icons'
import styles from './modal-user-profile.module.scss'
import './modal-user-profile.ant.scss'
import { Spin } from 'antd'

type PropsModalUserProfile = {
  className?: string
  centered?: boolean
  title?: string
  visible: boolean
  loading?: boolean
  disabledSave?: boolean
  maskClosable?: boolean
  closable?: boolean
  keyboard?: boolean
  showCancel?: boolean
  saveText?: string
  footer?: React.ReactNode
  onCancel: () => void
  onSave: () => void
}

const ModalUserProfile: FC<PropsModalUserProfile> = (props) => {
  const {
    title,
    visible,
    onCancel,
    onSave,
    loading = false,
    disabledSave = false,
    maskClosable = true,
    closable = true,
    keyboard = true,
    showCancel = true,
    saveText = 'Сохранить',
    footer,
    className = '',
    centered = false,
  } = props

  return (
    <Modal
      visible={visible}
      centered={centered}
      onCancel={onCancel}
      className={`${styles.modal} modal-user-profile ${className}`}
      zIndex={1200}
      destroyOnClose={true}
      maskClosable={maskClosable}
      closable={false}
      keyboard={keyboard}
      footer={null}
    >
      <header>
        <Title level={4}>{title}</Title>
        {closable ? <Close className={styles.closeIcon} onClick={onCancel} /> : null}
      </header>
      <section>
        <Spin spinning={loading}>{props.children}</Spin>
      </section>
      <footer>
        {footer ?? (
          <>
            <Button type="primary" onClick={onSave} loading={loading} disabled={disabledSave}>
              {saveText}
            </Button>
            {showCancel && <Button onClick={onCancel}>Отменить</Button>}
          </>
        )}
      </footer>
    </Modal>
  )
}

export default ModalUserProfile
